// extracted by mini-css-extract-plugin
module.exports = {"container":"signUp_container__3d9Rt","heading":"signUp_heading__2e0gr"};